import { z } from './utils/zod.js';
export const checkPhoneNumberResponseSchema = z.object({
    success: z.boolean(),
});
export const checkPhoneNumberRequestSchema = z.object({
    phoneNumber: z.string(),
});
export const geoCountryResponseSchema = z.object({
    country: z.string().length(2).nullable(),
});
